<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="400">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="success" dark v-on="on">transferer</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Transfert {{ action_type == 'bonus' ? 'Commission' :
          'Partenariat' }} </v-card-title>
        <v-card-text v-if="action_type == 'bonus'">
          <p @click="tout">disponible: <span class="green--text" style="cursor:pointer;" @click="tout">{{ new
            Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.floor(user.bonus))}}</span> fr </p>
          <v-text-field solo type="number" label="Montant" v-model="amount" class="first"></v-text-field>
          <v-flex xs12 text-xs-right>
            <v-btn v-if="amount >= 500 && amount <= user.bonus" color="success" small type="submit"
              @click="transfer">Transferer</v-btn>
          </v-flex>
        </v-card-text>

        <v-card-text v-if="action_type == 'partner'">
          <p @click="tout">disponible: <span class="green--text" style="cursor:pointer;" @click="tout">{{ new
            Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.floor(user.partn_cfa))}}</span> fr </p>
          <v-text-field solo type="number" label="Montant" v-model="amount" class="first"></v-text-field>
          <v-flex xs12 text-xs-right>
            <v-btn v-if="amount >= 500 && amount <= user.partn_cfa" color="success" small type="submit"
              @click="transfer">Transferer</v-btn>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="success" depressed @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


<!-- code pin validataion  dialog-->
    <div>
      <v-dialog v-model="dialog_2fa" max-width="800">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>
            <div style="display:block; text-align:center; margin:auto;">CODE {{ $store.getters['authfb/user'].auth2fa.google ? 'CODE 2FA': 'PIN' }} </div>
          </v-card-title>
          <v-card-text class="px-3 pt-1 mb-4">
            <div style="display:block; max-width:100%; text-align:center">
              <img src="/img/lock.svg" width="70" alt="">
            </div>
            <p class="caption" style="display:block; max-width:100%; text-align:center">Entrez le code à {{ $store.getters['authfb/user'].auth2fa.google ? 6 : 4 }} chiffres pour
              confirmer le transfert</p>
            <div class="pl-4" style="text-align:center">
              <input :class="authActivated ? 'code' : 'pin'" v-model="pin" type="number" maxlength=6 @input="handleInput"  onkeypress="if(this.value.length==6) return false;"/>
              <br />
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog_2fa = false">fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    
    bonus: {
      default: 0
    },

    total: {
      default: 0
    },

    action_type: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      dialog: false,
      maxlength:6,
      amount: '',
      dialog_2fa: false,
      code: '',
      pin: '',
      pass: process.env.VUE_APP_SECRET,
      totp_validate: process.env.VUE_APP_TOTP_VALIDATE,
    };
  },
  computed: {
    authActivated() {
      return this.$store.getters['authfb/user'].auth2fa.google
    },
    ...mapGetters({
      cfa: "authfb/cfa",
      user: "authfb/user"
    })
  },

  codeLength() {
    return this.authActivated ? 6 : 4;
  },

  watch: {
    pin(newValue, oldValue) {
      let codeLength = this.authActivated ? 6 : 4
      let code = newValue.slice(0, codeLength)
      console.log(code, codeLength);
      if (newValue.length == codeLength) {
        this.validate_transfer(newValue);
      }
    },
  },
  methods: {
    handleInput() {
      if (this.pin.length > this.codeLength) {
        this.pin = this.pin.slice(0, this.codeLength); // 
      }
    },

    transfer() {
      if (this.amount > Math.floor(this.total)) {
        console.log('solde insuffisant');
        swal("solde insuffisant", "", "error", {
          button: "ok!"
        })
        return
      }
      this.dialog_2fa = true;
    },
    async validate_transfer(token) {
      let valid = await this.valid_auth_pin(token)
      console.log(valid);
      if (valid) {
        console.log('valid');
        let auth_token = await this.firebase_auth_token()
        let base_url = this.base_url
        this.code = '';
        this.$store
          .dispatch("exchanged/transfer", {
            amount: Number(this.amount),
            auth_token,
            base_url,
            type: this.action_type
          }).then(() => {
            this.code = ''
            this.pin = ''
            this.dialog_2fa = false;
            this.amount = ''
          })
      } else {
        swal("code invalide!", "", "error", {
          button: "ok!"
        })
        this.code = ''
        this.pin = ''
      }

    },

    tout() {
      this.amount = Number(Math.floor(this.total))
    }
  },

};
</script>

<style scoped lang="scss">
td.md-table-cell {
  font-size: 1.2em;
}

.first {
  max-width: 200px !important;
  display: block;
  margin: auto;

}

div.v-input.first {
  font-size: 2em !important;
  align-content: center;
}

$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 6;
$in-w: $n-char * ($char-w + $gap);

input.code {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(90deg,
    dimgrey 0,
    dimgrey $char-w,
    transparent 0,
    transparent $char-w + $gap ) 0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}


$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 4;
$in-w: $n-char * ($char-w + $gap);

input.pin {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(90deg,
    dimgrey 0,
    dimgrey $char-w,
    transparent 0,
    transparent $char-w + $gap ) 0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}
</style>

<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
